let k = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65],
	n = 0;
$(document).keydown(function (e) {
	if (e.keyCode === k[n++]) {
		if (n === k.length) {
			$('body').addClass('konami')
			$('body').html('<a href="https://ocsalis.fr" class="entete" target="_blank"></a>');
			$('<div>', {	class: 'carnivore'}).appendTo('body');
			$('<div>', {	class: 'plante plantes1'}).appendTo('body');
			$('<div>', {	class: 'plante plantes2'}).appendTo('body');
			$('<div>', {	class: 'cube4Coin'}).appendTo('body');
			$('<div>', {	class: 'cube cube1'}).appendTo('body');
			$('<div>', {	class: 'cube cube5'}).appendTo('body');
			$('<div>', {	class: 'cube cube2'}).appendTo('body');
			$('<div>', {	class: 'cube cube3'}).appendTo('body');
			$('<div>', {	class: 'cube cube4'}).appendTo('body');
			$('<div>', {	class: 'piece piece1'}).appendTo('body');
			$('<div>', {	class: 'piece piece2'}).appendTo('body');
			$('<div>', {	class: 'piece piece3'}).appendTo('body');
			$('<div>', {	class: 'piece piece4'}).appendTo('body');
			$('<div>', {	class: 'monstre'}).appendTo('body');
			$('<div>', {	class: 'flour'}).appendTo('body');
			$('<div>', {	class: 'pipe'}).appendTo('body');
			$('<div>', {	class: 'mario'}).appendTo('body');
			const audio = new Audio("https://ocsalis.github.io/external_project/konami/theme.mp3" );
			let coin = new Audio("https://ocsalis.github.io/external_project/konami/theme.mp3" );

			var thememusic  = new Audio();
			var sourcemusic  = document.createElement("source");
			sourcemusic.type = "audio/mp3";
			sourcemusic.src  = "https://ocsalis.github.io/external_project/konami/theme.mp3";
			thememusic.appendChild(sourcemusic);

			var themecoin  = new Audio();
			var sourcecoin  = document.createElement("source");
			sourcecoin.type = "audio/mp3";
			sourcecoin.src  = "https://ocsalis.github.io/external_project/konami/coin.mp3";
			themecoin.appendChild(sourcecoin);
			thememusic.play();


			let cube4 = $('.cube4')
			let cube4Coin = $('.cube4Coin ')
			if(cube4.length){
				cube4.click(function(){
					// audio.play()
					themecoin.play()

					cube4Coin.toggleClass('active')
					setTimeout(function(){
						cube4Coin.toggleClass('active')
					},1500);
					// cube4Coin.removeClass('active')

					// alert('sdf')

				})
			}

			thememusic.play()

			n = 0;
			return false;
		}
	}
	else {
		n = 0;
	}
});



